export const routes = {
    INITIATE_PAYMENT: 'initiate',
    CONFIRM_PAYMENT: 'confirm',
    STATUS_PAYMENT: 'status',
    NOT_FOUND: '404',
}